export function onLoadEvents(APP) {
  let previousViewportHeight = null;
  APP.user = {
    isTabbing: undefined,
  };

  const setViewportHeightVariable = () => {
    if (previousViewportHeight === window.innerHeight) return;
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    previousViewportHeight = window.innerHeight;
  }
  setViewportHeightVariable();
  window.addEventListener('resize', setViewportHeightVariable);

  // if user is tabbing
  document.body.addEventListener('keydown', (e) => {
    if (!e.keyCode === 9) return;
    APP.user.isTabbing = true;
  });

  // if user is not tabbing
  document.body.addEventListener('mousemove', () => {
    if (!APP.user.isTabbing) return;
    APP.user.isTabbing = false;
  });
}
